import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';

@Injectable()
export class ScrollToTopService {

  public scrollToTop$: Observable<number>;
  private scrollToTopSource = new Subject<number>();

  constructor() {
    this.scrollToTop$ = this.scrollToTopSource.asObservable();
  }

  scrollToTop(speed: number = 500): void { this.scrollToTopSource.next(speed); }
}
